import {MatAccordion} from '@angular/material/expansion';


import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Pipe,
  PipeTransform,
  ViewChildren,
  QueryList,
  AfterViewChecked, ChangeDetectorRef
} from '@angular/core';
import {jsPDF} from "jspdf";
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatMenuTrigger} from '@angular/material/menu';

import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import Swal from 'sweetalert2/dist/sweetalert2.js'


import html2canvas from 'html2canvas';

import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

import {CircleProgressComponent} from 'ng-circle-progress';
import {id} from '@swimlane/ngx-charts';
import {Router} from '@angular/router';
import {PDFfile} from 'src/app/device/PDFfile';
import {UserUtils} from 'src/app/user/UserUtils';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {environment} from '../../../environments/environment'
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {TraslateService} from 'src/app/traslate.service';
import {element} from 'protractor';
import {ErrorStateMatcher} from '@angular/material/core';
import {CountryServiceService} from 'src/app/country-service.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {async} from 'rxjs/internal/scheduler/async';
import {EditDriveruser} from "../../driver/driver.component";

@Component({
  selector: 'app-companypartner',
  templateUrl: './companypartner.component.html',
  styleUrls: ['./companypartner.component.scss']
})


export class CompanypartnerComponent implements OnInit, AfterViewChecked {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  companypartnerData: any;
  dataSource: any;
  ExportData: any;
  alldata: any;
  companypartnerData2: any
  dataSource1: any;
  dataSource3: MatTableDataSource<any>;
  // @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChild('paginator', {static: true}) paginator: MatPaginator;
  itemSelected: any;
  listItems: any[] = [];
  lengthSelected: number;
  IconOnItems: string;
  inputEt: boolean;
  name: any;
  id: any;
  email: any;
  gsm_number: any;
  count_drivers: any;
  count_units: any;
  count_users: any;
  hiddenItemClick: any = 0;
  idSelected: any;
  reseller_id: any;
  partnercompany: boolean;
  partnercompanyrevendeur: boolean;
  nameSelected: any;
  pageSizeOptions = [15, 30, 100];
  pageSize: any = 15;
  showtyppart: any = 1;
  showtyppartTable: any = [{name: "STG", type: 1, logo: "null "}, {name: "Orange", type: 2, logo: "null "}];
  compoTypeTable = [{name: "STG TELEMATICS", type: 1, logo: "null "}, {name: "ORANGE", type: 2, logo: "null "}]
  compoTypeTableObjt: any = {name: "STG", type: 1, logo: "null "}
  showtyppartLoad: any = 1;
  url = '';
  spinnerActivePartner: boolean = false;
  pageIndex: any;
  compagnies: any;
  filterValue: string = "";

  constructor(private router: Router, private http: HttpClient, public dialog: MatDialog,
              public traslateService: TraslateService, private spinnerusercompany: NgxSpinnerService, private cdRef: ChangeDetectorRef) {
  }
  DefaultRev = 1
  currentlyOpenedItemIndex = -1;

  ngOnInit(): void {
    this.getDataTest()
    this.getItemData(1, {id: 1});
  }

  OldeSelectRote: any;

  doubleClicktable() {
    this.OldeSelectRote = this.selection;
  }

  matcher = new MyErrorStateMatcher();

  pageChanged(event) {
    this.pageIndex = event.pageIndex;
    const pageSize = event.pageSize;
    const previousIndex = event.previousPageIndex;
    const previousSize = pageSize * this.pageIndex;
    this.getNextData(previousSize, (this.pageIndex + 1).toString());
  }

  getNextData(currentSize, offset) {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.url = environment.apiUrl + '/resellers/' + this.showtyppart + '/companies?name=' + this.filterValue + '&page=' + offset;
    this.http.get(this.url, requestOptions).subscribe((response: any) => {
      let list = response.companies.data;
      list.length = response.companies.total;
      this.compagnies.length = currentSize;
      this.compagnies.push(...list);
      this.dataSource = new MatTableDataSource([]);
      this.compagnies.length = response.companies.total;
      this.dataSource3 = new MatTableDataSource<any>(this.compagnies);
      this.dataSource._updateChangeSubscription();
      this.dataSource3.paginator = this.paginator;
    });
  }

  async dblclickdetails(select) {
    this.lengthSelected = this.listItems.length
    this.lengthSelected = this.listItems.length
    this.lengthSelected = this.listItems.length

    this.id = select.id
    this.name = select.name
    this.email = select.email
    this.gsm_number = select.gsm_number
    this.count_drivers = select.count_drivers
    this.count_units = select.count_units
    this.count_users = select.count_users


    const {value: formValues} = await Swal.fire({

      imageUrl: "https://i.pinimg.com/originals/30/f8/f7/30f8f7eaa9f4dcfa506df11ddae32de2.gif",
      imageSize: '600x600',
      confirmButtonText: 'OK!',
      html:

        '<h1 class="pb-4" style="color :#3b5876;" > <strong> Détails de la compagnie sélectionnée</strong>   <h1>' +
        '<h2 style="color :#3b5876;" > <strong> Nom :</strong>  ' + this.name + ' <h2>' +
        '<h2 style="color :#3b5876;" ><strong> Compagnie : </strong> ' + this.name + ' <h2>' +
        '<h2 style="color :#3b5876;" ><strong> Adresse email : </strong> ' + this.email + ' <h2>' +
        '<h2 style="color :#3b5876;" ><strong> Numéro de téléphone  : </strong> ' + this.gsm_number + ' <h2>' +
        '<h2 style="color :#3b5876;" ><strong> Nombre de conducteurs : </strong> ' + this.count_drivers + ' <h2>' +
        '<h2  style="color :#3b5876;" ><strong> Nombre de véhicules : </strong> ' + this.count_units + ' <h2>' +
        '<h2  style="color :#3b5876;" ><strong> Nombre d"utilisateurs : </strong> ' + this.count_users + ' <h2>'

    })
  }

  changepartnetType(type) {
    this.showtyppart = type.type;
    this.compoTypeTableObjt = this.compoTypeTable.find(objt => objt.type == type.type);
    this.showtyppartLoad = 0
    this.getItemData(type.type, {id: 1})
  }

  exportExcel(e2) {
    Swal.fire({
      title: 'Souhaitez-vous exporter la table ?',
      showCancelButton: true,
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
      confirmButtonText: 'Exporter Fichier !',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.value) {
        Swal.fire(
          'le fichier est exporté'
        )

        this.ExportData.exportTable(e2)
        /* var filename ='incoming message'

        const workSheet = XLSX.utils.json_to_sheet(this.dataSource.data, {header:["A","B","C","D","E","F",""], skipHeader:false});
        const workBook: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workBook, workSheet, 'SheetName');
        XLSX.writeFile(workBook, filename+new Date()+'.xlsx'); */


        // For more information about handling dismissals please visit
        // https://sweetalert2.github.io/#handling-dismissals
      } else if (result.dismiss === Swal.DismissReason.cPDFfileancel) {
        Swal.fire(
          'Annulé',
          'Fichier non exporté !!'
        )
      }
    })
  }

  supprimerCompany(operation, id: any, reseller_id: any) {
    if (operation == 'oneItem') {
      this.selection.clear()
      this.listItems = []
      this.arr = []
      this.listItems.push({
        id: id,
        reseller_id: reseller_id
      })
    }
    for (var i = 0; i < this.listItems.length; i++) {
      var obj = {}; // <---- Move declaration inside loop

      obj['id'] = this.listItems[i].id;

      this.arr.push(this.listItems[i].id);
      this.reseller_id = this.listItems[i].reseller_id;
    }
    Swal.fire({
      title: "Voulez-vous supprimer cette compagnie?",
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonText: 'Oui',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        this.partnercompanyrevendeur = true
        this.partnercompany = true
        this.spinnerusercompany.show();
        this.http.delete(environment.apiUrl + '/companies/' + JSON.stringify(this.arr)).subscribe((response) => {
          // this.getgogo()
          this.listItems = []
          this.arr = []
          this.selection.clear();
          this.getCompanie(this.reseller_id)
          this.partnercompany = false
          this.selection.clear();
          this.hiddenItemClick = 0

        })
      } else {
        this.arr = []
        this.listItems = []
        this.selection.clear()
      }
    })
  }

  getgogo() {
    this.hiddenItemClick = this.selection.selected.length
    this.selection.selected.forEach(element => {
      this.idSelected = element.id;
      this.nameSelected = element.name
    });
  }

  getOeuvresByTaskId() {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.partnercompanyrevendeur = true
    this.spinnerusercompany.show();
    var nameSearchElement: any = (<HTMLInputElement>document.getElementById('searchInput')).value.trim().toLowerCase()

    this.http.get(environment.apiUrl + '/resellers', requestOptions).subscribe((response) => {
      var list: any = response
      this.companypartnerData = list.resellers
      this.companypartnerData2 = list.resellers
      if (nameSearchElement.length != 0) {
        this.companypartnerData = this.companypartnerData.filter(function (el) {
          return el.name.trim().toLowerCase().includes(nameSearchElement);
        });
        this.spinnerusercompany.hide();
        this.partnercompanyrevendeur = false
      } else {

        this.companypartnerData = this.companypartnerData2
        this.spinnerusercompany.hide();
        this.partnercompanyrevendeur = false
      }
    })
  }

  getCompanie(e) {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.spinnerusercompany.show();
    this.http.get(environment.apiUrl + '/resellers/' + e + '/companies', requestOptions).subscribe((response: any) => {

      this.compagnies = response.companies.data
      this.compagnies.push(...response.companies.data)
      this.compagnies.length = response.companies.total;
      this.dataSource3 = new MatTableDataSource(this.compagnies)
      this.dataSource3._updateChangeSubscription();
      this.paginator.pageIndex = 0;
      this.dataSource3.paginator = this.paginator;
      this.spinnerusercompany.hide();
      this.partnercompany = false

    })
  }

  async getItemsbyClick() {
    this.lengthSelected = this.listItems.length
    this.lengthSelected = this.listItems.length
    this.lengthSelected = this.listItems.length

    for (let entry of this.listItems) {
      this.id = entry.id
      this.name = entry.name
      this.email = entry.email
      this.gsm_number = entry.gsm_number
      this.count_drivers = entry.count_drivers
      this.count_units = entry.count_units
      this.count_users = entry.count_users
    }


    const {value: formValues} = await Swal.fire({
      imageUrl: "https://i.pinimg.com/originals/30/f8/f7/30f8f7eaa9f4dcfa506df11ddae32de2.gif",
      imageSize: '600x600',
      confirmButtonText: 'OK!',
      html:
        '<h1 class="pb-4" style="color :#3b5876;" > <strong> Détails de la compagnie sélectionnée</strong>   <h1>' +
        '<h2 style="color :#3b5876;" > <strong> Nom :</strong>  ' + this.name + ' <h2>' +
        '<h2 style="color :#3b5876;" ><strong> Compagnie : </strong> ' + this.name + ' <h2>' +
        '<h2 style="color :#3b5876;" ><strong> Adresse email : </strong> ' + this.email + ' <h2>' +
        '<h2 style="color :#3b5876;" ><strong> Numéro de téléphone  : </strong> ' + this.gsm_number + ' <h2>' +
        '<h2 style="color :#3b5876;" ><strong> Nombre de conducteurs : </strong> ' + this.count_drivers + ' <h2>' +
        '<h2  style="color :#3b5876;" ><strong> Nombre de véhicules : </strong> ' + this.count_units + ' <h2>' +
        '<h2  style="color :#3b5876;" ><strong> Nombre d"utilisateurs : </strong> ' + this.count_users + ' <h2>'
    })
  }

  getItemData(e, ee) {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.partnercompany = true
    this.spinnerusercompany.show();
    this.http.get(environment.apiUrl + '/resellers/' + e + '/companies', requestOptions).subscribe((response: any) => {
      this.compagnies = response.companies.data
      this.compagnies.length = response.companies.total;
      this.dataSource = new MatTableDataSource(this.compagnies)
      this.dataSource3 = new MatTableDataSource(this.compagnies)
      this.dataSource3.paginator = this.paginator
      this.spinnerusercompany.hide();
      this.partnercompany = false
      this.selection.clear();

      this.hiddenItemClick = 0
    })
  }

  setOpened(itemIndex) {
    this.currentlyOpenedItemIndex = itemIndex;
  }

  setClosed(itemIndex) {
    if (this.currentlyOpenedItemIndex === itemIndex) {
      this.currentlyOpenedItemIndex = -1;
    }
  }


  applyFilter(event: Event, ee) {

    this.filterValue = (event.target as HTMLInputElement).value;
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.url = environment.apiUrl + '/resellers/' + this.showtyppart + '/companies?name=' + this.filterValue;
    this.http.get(this.url, requestOptions).subscribe((response: any) => {
      this.compagnies = response.companies.data
      this.compagnies.length = response.companies.total;
      this.dataSource = new MatTableDataSource(this.compagnies)
      this.dataSource3 = new MatTableDataSource(this.compagnies)
      this.paginator.pageIndex = 0;
      this.dataSource3.paginator = this.paginator
    });

  }


  displayedColumns: string[] = ['select', 'Nom', 'Véhicules', 'Personnes', 'Utilisateurs', 'users'];
  selection = new SelectionModel(true, []);


  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection?.selected?.length;
    const numRows = this.dataSource?.data?.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {

    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    this.listItems = this.selection.selected
    this.lengthSelected = this.listItems.length
    if (this.lengthSelected == 1) {

      this.IconOnItems = 'ctive'

      //this.IconOnn =true
      //( <HTMLInputElement> document.getElementById("Button") ).disabled = false;
      this.inputEt = false
    }

    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }


  async getDataTest() {


    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.partnercompanyrevendeur = true
    this.spinnerusercompany.show();

    this.http.get(environment.apiUrl + '/resellers', requestOptions).subscribe((response) => {

      var list: any = response



      this.companypartnerData = list.resellers

      this.companypartnerData2 = list.resellers
      this.spinnerusercompany.hide();
      this.partnercompanyrevendeur = false

    })


  }


  // we create an object that contains coordinates
  menuTopLeftPosition = {x: '0', y: '0'}

  // reference to the MatMenuTrigger in the DOM
  @ViewChild(MatMenuTrigger, {static: true}) matMenuTrigger: MatMenuTrigger;

  /**
   * Method called when the user click with the right button
   * @param event MouseEvent, it contains the coordinates
   * @param item Our data contained in the row of the table
   */
  arr: any = []

  onRightClick(event: MouseEvent, item, row) {
    // preventDefault avoids to show the visualization of the right-click menu of the browser
    event.preventDefault();

    // we record the mouse position in our object
    this.menuTopLeftPosition.x = event.clientX + 'px';
    this.menuTopLeftPosition.y = event.clientY + 'px';

    // we open the menu
    // we pass to the menu the information about our object
    this.matMenuTrigger.menuData = {item: item}
    this.ExportData = item
    // we open the menu
    this.matMenuTrigger.openMenu();


    this.itemSelected = row


  }

  deleteCompany() {
    for (var i = 0; i < this.listItems.length; i++) {
      var obj = {}; // <---- Move declaration inside loop

      obj['id'] = this.listItems[i].id;

      this.arr.push(this.listItems[i].id);
    }
    this.partnercompanyrevendeur = true
    this.spinnerusercompany.show();
    this.http.delete(environment.apiUrl + '/companies/' + JSON.stringify(this.arr)).subscribe((response) => {
      this.spinnerusercompany.hide();
      this.partnercompanyrevendeur = false

      location.reload()
    })
  }


  RedirectCompanyUser(e, e1, e2, icon) {

    this.router.navigate(['/admin/companyuser/' + e2 + '/' + e1 + '/' + e]);
  }


  exportDeviceTablePDF() {
    Swal.fire({
      title: 'Souhaitez-vous exporter la table type PDF?',
      showCancelButton: true,
      confirmButtonText: 'Démarrer l\'exportation!',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.value) {


        UserUtils.exportToPdf("ExampleTablecompany", "tbl");

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Annulé',
          'Fichier non exporté !!'
        )
      }
    })


  }


  exportDeviceTable(exportDirective, typeFile) {

    Swal.fire({
      title: 'Souhaitez-vous exporter la table type ' + typeFile + ' ?',
      showCancelButton: true,
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
      confirmButtonText: 'Démarrer l\'exportation',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.value) {
        Swal.fire(
          'Export!',
          'le fichier est exporté'
        )
        exportDirective.exportTable(typeFile)
        /* var filename ='incoming message'

        const workSheet = XLSX.utils.json_to_sheet(this.dataSource.data, {header:["A","B","C","D","E","F",""], skipHeader:false});
        const workBook: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workBook, workSheet, 'SheetName');
        XLSX.writeFile(workBook, filename+new Date()+'.xlsx'); */


        // For more information about handling dismissals please visit
        // https://sweetalert2.github.io/#handling-dismissals
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Annulé',
          'Fichier non exporté !!'
        )
      }
    })

  }


  addCompanyPartner() {


    this.dialog.open(AddCompanyPartner, {

      data: {
        animal: 'panda'

      },

      width: '50%',
      autoFocus: false,
      panelClass: ['my-custom-dialog-class'],

    });


  }


  updateCompanyPartner(operation, row) {


    let dialogRef = this.dialog.open(UpdateCompanyPartner, {

      data: {
        animal: 'panda'
      },
      disableClose: true,
      width: '50%',
      autoFocus: false,
      panelClass: ['my-custom-dialog-class'],
    });
    if (operation == 'oneItem') {
      this.selection.clear()
      this.listItems = []
      this.arr = []
      this.listItems.push(row)
    }
    this.traslateService.urlcompanyQuote.next(this.listItems)
    //  after closed
    dialogRef.afterClosed().subscribe(result => {
      this.selection.clear()
      this.listItems = []
      this.arr = []

    });
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

}


@Component({
  selector: 'updateCompanyPartner',
  templateUrl: 'updateCompanyPartner.html',
  styleUrls: ['./companypartner.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: {showError: true}
  }]
})
export class UpdateCompanyPartner {
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  url: any;
  revendeur: any;
  revendeurs: any;
  selectedRevendeur: any;
  jsonArray1: any;
  jsonArray2: any;
  entry: any;
  reseller_id: any;
  phone_number: any;
  gsm_number: any;
  email: any;
  name: any;
  nameTitle : any;
  id: any;
  countryInfo: any[] = [];
  cityInfo: any[] = [];
  county: any;
  city: any;
  stateInfo: any;
  partnercompanycompanie: boolean;

  constructor(public dialogRef: MatDialogRef<AddCompanyPartner>, private _formBuilder: FormBuilder, public traslateService: TraslateService, private http: HttpClient, private countryService: CountryServiceService, private spinnerusercompany: NgxSpinnerService) {
  }

  getCountries() {
    this.countryService.allCountries().subscribe(
      data2 => {
        this.countryInfo = data2.Countries;
      },
      err => {
      },
      () => {
      }
    )
  }
  getItemsRes(revendeur){
    this.reseller_id = revendeur.id
  }
  onChangeCountry(countryValue) {

    this.stateInfo = this.countryInfo[countryValue.value].States;
    this.cityInfo = this.stateInfo[0].Cities;
  }

  ngOnInit(): void {
    this.getCountries();
    this.traslateService.currentcompanyQuote.subscribe(data => {
      this.url = data
    })
    for (let entry of this.url) {
      this.id = entry.id
      this.name = this.nameTitle = entry.name
      this.email = entry.email
      this.gsm_number = entry.gsm_number
      this.reseller_id = entry.reseller_id
    }
    this.traslateService.currentdataQuote.subscribe(data => {
      this.url = data

    })
    this.firstFormGroup = this._formBuilder.group({
      name: ['', {validators: [Validators.required, Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/)], updateOn: "change"}],
      reseller_id: ['', {validators: Validators.required, updateOn: "change"}],
      email: ['', {validators: [Validators.email], updateOn: "change"}],
      gsm_number: ['', {
        validators: [

          Validators.pattern("^[0-9]*$"),

        ], updateOn: "change"
      }],

    });


    this.traslateService.obs2.subscribe((response) => {
      this.traslateService.getRevendeur();
      this.revendeur = response;
      this.click2()
    });
  }

  matcher = new MyErrorStateMatcher();

  jsonConcat(o1, o2) {
    for (var key in o2) {
      o1[key] = o2[key];
    }
    return o1;
  }


  click2() {
    this.revendeurs = this.revendeur.resellers
    this.selectedRevendeur = this.revendeur.resellers[1].name
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  submitForm() {


    //var jsonArray3:any =  this.jsonArray2.concat(this.jsonArray1 );
    //this.dialogRef.close();


    //location.reload()


    this.partnercompanycompanie = true
    this.spinnerusercompany.show();
    this.firstFormGroup.get('reseller_id').setValue(this.reseller_id)
    this.http.put(environment.apiUrl + '/companies/' + this.id, this.firstFormGroup.value).subscribe(data => {
      var statusNumber: any = data

      if (statusNumber.status == 200) {
        Swal.fire({
          position: 'center',
          title: 'Modification enregistré avec succès!',
          showConfirmButton: false,
          timer: 1000
        })
        this.spinnerusercompany.hide();
        this.partnercompanycompanie = false

        window.location.reload();
      } else {
        this.spinnerusercompany.hide();
        this.partnercompanycompanie = false
        Swal.fire({
          text: statusNumber.message.join('<br>'),

        })
      }
    })

  }


}


@Component({
  selector: 'addCompanyPartner',
  templateUrl: 'addCompanyPartner.html',
  styleUrls: ['./companypartner.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: {showError: true}
  }]
})
export class AddCompanyPartner {
  firstFormGroup: FormGroup;

  url: any;
  revendeur: any;
  revendeurs: any;
  selectedRevendeur: any;
  jsonArray1: any;
  jsonArray2: any;
  countryInfo: any[] = [];
  cityInfo: any[] = [];
  county: any;
  city: any;
  stateInfo: any;
  partnercompanycompanie: boolean;

  constructor(public dialogRef: MatDialogRef<AddCompanyPartner>, private _formBuilder: FormBuilder, public traslateService: TraslateService, private http: HttpClient, private countryService: CountryServiceService, private spinnerusercompany: NgxSpinnerService) {
  }

  getCountries() {
    this.countryService.allCountries().subscribe(
      data2 => {
        this.countryInfo = data2.Countries;
      },
      err => {
      },
      () => {
      }
    )
  }

  onChangeCountry(countryValue) {

    this.stateInfo = this.countryInfo[countryValue.value].States;
    this.cityInfo = this.stateInfo[0].Cities;
  }

  ngOnInit(): void {

    this.getCountries();
    this.traslateService.currentdataQuote.subscribe(data => {
      this.url = data

    })
    this.firstFormGroup = this._formBuilder.group({
      name: ['', {validators: [Validators.required, Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/)], updateOn: "change"}],
      reseller_id: ['', {validators: Validators.required, updateOn: "change"}],
      email: ['', {validators: [Validators.email], updateOn: "change"}],
      gsm_number: ['', {
        validators: [

          Validators.pattern("^[0-9]*$"),

        ], updateOn: "change"
      }],

    });


    this.traslateService.obs2.subscribe((response) => {
      this.traslateService.getRevendeur();
      this.revendeur = response;
      this.click2()
    });
  }

  matcher = new MyErrorStateMatcher();

  jsonConcat(o1, o2) {
    for (var key in o2) {
      o1[key] = o2[key];
    }
    return o1;
  }


  click2() {
    this.revendeurs = this.revendeur.resellers
    this.selectedRevendeur = this.revendeur.resellers[1].name
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  submitForm() {


    Object.values(this.firstFormGroup).forEach(val => {
      this.jsonArray1 = val;
    });


    //var jsonArray3:any =  this.jsonArray2.concat(this.jsonArray1 );
    //this.dialogRef.close();


    this.partnercompanycompanie = true
    this.spinnerusercompany.show();
    this.http.post(environment.apiUrl + '/companies', this.firstFormGroup.value).subscribe(data => {
      var statusNumber: any = data

      // location.reload()
      if (statusNumber.status == 200) {
        Swal.fire({
          position: 'center',
          title: 'Companie enregistré avec succès!',
          showConfirmButton: false,
          timer: 1000
        })

        this.spinnerusercompany.hide();
        this.partnercompanycompanie = false

        window.location.reload();
      } else {
        this.spinnerusercompany.hide();
        this.partnercompanycompanie = false

        window.location.reload();
        Swal.fire({
          text: statusNumber.message.join('<br>'),
        })
      }

    })

  }


}


export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
